// TODO: fix the eslint errors and remove the eslint-disable comments
/* eslint-disable max-lines */
/* eslint-disable react/no-unused-prop-types */
/* eslint-disable max-len */
/* eslint-disable react/prop-types */
/* eslint-disable react/destructuring-assignment */
/* eslint-disable no-unused-vars */
/* eslint-disable react/no-unused-state */
import React, { Component } from 'react';
import PropTypes from 'prop-types';

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import i18n from 'i18n-react';
// import { Multiselect } from 'multiselect-react-dropdown';
import { HashLink as Link } from 'react-router-hash-link';

import InputField from 'components/LoginForm/Input';

import agencyAffiliations from '../Register/registerAgencyAffiliationsData';
// import businessDescriptions from '../Register/registerBusinessDescriptionsData';
import countries from '../Register/registerCountriesData';
import hostAgencies from '../Register/registerHostAgenciesData';
import states from '../Register/registerStatesData';

export default class RegisterTrade extends Component {
  constructor(props) {
    super(props);
    this.state = {
      selectedValue: '',
      selectedItems: [],
      options: [
        { name: 'Family', id: 'Family' },
        { name: 'Culture', id: 'Culture' },
        { name: 'Adventure', id: 'Adventure' },
        { name: 'Wellness', id: 'Wellness' },
        { name: 'Luxury', id: 'Luxury' },
        { name: 'Culinary', id: 'Culinary' },
        { name: 'Business Travel', id: 'Business Travel' },
      ],
    };
  }

  render() {
    const { selectedValue, options } = this.state;

    return (
      <div className="Register">
        <p htmlFor="reg_agency_business" />
        <br />
        <InputField
          defaultVal={this.props.defaultVal}
          change={this.props.change}
          fieldType="email"
          fieldName="reg_email"
          fieldPlaceholder={i18n.translate('loginScreen.fields.email')}
          icon="envelope"
          line
          disabledField={window.location.pathname === '/login/quick-register'}
          required
        />

        {this.props.passwordField && (
          <InputField
            change={this.props.change}
            fieldType="password"
            fieldName="reg_password"
            fieldPlaceholder={i18n.translate('loginScreen.version2.fields.passwordRegister')}
            icon="key"
            line
          />
        )}

        {this.props.passwordField && (
          <InputField
            change={this.props.change}
            fieldType="password"
            fieldName="reg_passwordConfirm"
            fieldPlaceholder={i18n.translate('loginScreen.version2.fields.passwordConfirm')}
            icon="key"
            line
          />
        )}

        <div className="step space-top">{i18n.translate('loginScreen.version2.step3')}</div>
        <h5>
          <b>{i18n.translate('loginScreen.version2.step2Sub1')}</b>
        </h5>

        <InputField
          change={this.props.change}
          fieldType="text"
          fieldName="reg_first_name"
          fieldPlaceholder={i18n.translate('loginScreen.version2.fields.firstName')}
          icon="user"
          line
          defaultVal={this.props.userInput.reg_first_name}
          required
        />

        <InputField
          change={this.props.change}
          fieldType="text"
          fieldName="reg_last_name"
          fieldPlaceholder={i18n.translate('loginScreen.version2.fields.lastName')}
          icon="user"
          line
          defaultVal={this.props.userInput.reg_last_name}
          required
        />

        <p htmlFor="reg_country" className="reg_country">
          {i18n.translate('loginScreen.version2.fields.country')} {'*'}
        </p>
        <select
          id="reg_country"
          name="reg_country"
          onChange={this.props.change}
          value={this.props.userInput.reg_country}
        >
          <option value="" disabled selected>
            {i18n.translate('loginScreen.version2.fields.select')}
          </option>
          {countries.map((c, index) => {
            const key = index;
            return (
              <option key={key} value={c.code}>
                {c.name}
              </option>
            );
          })}
        </select>

        <InputField
          change={this.props.change}
          fieldType="text"
          fieldName="reg_zip_code"
          fieldPlaceholder={
            this.props.country === 'US'
              ? i18n.translate('loginScreen.version2.fields.zipCode')
              : i18n.translate('loginScreen.version2.fields.postalCode')
          }
          icon="user"
          line
          defaultVal={this.props.userInput.reg_zip_code}
          required
        />

        <InputField
          change={this.props.change}
          fieldType="text"
          fieldName="reg_city"
          fieldPlaceholder={i18n.translate('loginScreen.version2.fields.city')}
          icon="user"
          line
          defaultVal={this.props.userInput.reg_city}
          required
        />

        {this.props.country !== 'US' && (
          <InputField
            change={this.props.change}
            fieldType="text"
            fieldName="reg_state"
            fieldPlaceholder={i18n.translate('loginScreen.version2.fields.province')}
            icon="map"
            line
            defaultVal={this.props.userInput.reg_state}
            required
          />
        )}

        {this.props.country === 'US' && (
          <React.Fragment>
            <p htmlFor="reg_state" className="reg_state">
              {i18n.translate('loginScreen.version2.fields.state')} {'*'}
            </p>
            <select id="reg_state" name="reg_state" onChange={this.props.change} value={this.props.userInput.state}>
              <option value="" disabled selected>
                {i18n.translate('loginScreen.version2.fields.select')}
              </option>
              {states.map((c, index) => {
                const key = index;
                return (
                  <option key={key} value={c.value}>
                    {c.label}
                  </option>
                );
              })}
            </select>
          </React.Fragment>
        )}

        <h5 style={{ marginTop: '5rem' }}>
          <b>{i18n.translate('loginScreen.version2.step2Sub2')}</b>
        </h5>

        <InputField
          change={this.props.change}
          fieldType="text"
          fieldName="reg_agency_name"
          fieldPlaceholder={i18n.translate('loginScreen.version2.fields.agency')}
          icon="home"
          line
          defaultVal={this.props.userInput.reg_agency_name}
          required
        />

        {this.props.country === 'US' && (
          <React.Fragment>
            <p htmlFor="reg_agency_affiliation" className="reg_agency_affiliation">
              {i18n.translate('loginScreen.version2.fields.affiliate')} {'*'}
            </p>
            <select
              id="reg_agency_affiliation"
              name="reg_agency_affiliation"
              onChange={this.props.change}
              value={this.props.userInput.reg_agency_affiliation}
            >
              <option value="" disabled selected>
                {i18n.translate('loginScreen.version2.fields.select')}
              </option>
              {agencyAffiliations.map((c, index) => {
                const key = index;
                return (
                  <option key={key} value={c.value}>
                    {c.label}
                  </option>
                );
              })}
            </select>
          </React.Fragment>
        )}

        {this.props.country === 'US' && (
          <React.Fragment>
            <p htmlFor="reg_host_agency_name">
              {i18n.translate('loginScreen.version2.fields.hostAgency')}
              {' *'}
            </p>
            <select
              id="reg_host_agency_name"
              name="reg_host_agency_name"
              onChange={this.props.change}
              value={this.props.userInput.reg_host_agency_name}
            >
              <option value="" disabled selected>
                {i18n.translate('loginScreen.version2.fields.select')}
              </option>
              {hostAgencies.map((c, index) => {
                const key = index;
                return (
                  <option key={key} value={c.value}>
                    {c.label}
                  </option>
                );
              })}
            </select>
          </React.Fragment>
        )}

        {this.props.country !== 'US' && (
          <React.Fragment>
            <p htmlFor="reg_agency_business" className="reg_margin_top">
              {i18n.translate('loginScreen.version2.fields.describes')} {'*'}
            </p>
            <select
              id="reg_agency_business"
              name="reg_agency_business"
              onChange={this.props.change}
              value={this.props.userInput.reg_agency_business}
            >
              <option value="" disabled selected>
                {i18n.translate('loginScreen.version2.fields.select')}
              </option>
              <option value="Retail Store Front ">{i18n.translate('loginScreen.version2.fields.retail')}</option>
              <option value="Home-Based Agent ">{i18n.translate('loginScreen.version2.fields.home')}</option>
              <option value="Independent Contractor ">
                {i18n.translate('loginScreen.version2.fields.independent')}
              </option>
              <option value="Host Agency ">{i18n.translate('loginScreen.version2.fields.host')}</option>
              <option value="Call Center or Web-Based Agency ">
                {i18n.translate('loginScreen.version2.fields.call')}
              </option>
              <option value="Other">{i18n.translate('loginScreen.version2.fields.other')}</option>
            </select>
          </React.Fragment>
        )}

        <div className="privacy">
          <b>{i18n.translate('loginScreen.version2.privacyHead')}</b>
        </div>

        {this.props.country && (
          <span key={this.props.country}>
            <span className="checkItem">
              <InputField
                key={this.props.userInput.opt_in_marketing}
                change={this.props.change}
                fieldLabel={i18n.translate('loginScreen.version2.fields.opt')}
                fieldName="opt_in_marketing"
                fieldType="checkbox"
                icon="envelope"
                line={false}
                title={i18n.translate('loginScreen.fields.opt')}
                checked={this.props.userInput.opt_in_marketing}
                required={false}
                userSelect={false}
              />
            </span>

            <span className="checkItem">
              <InputField
                change={this.props.change}
                fieldLabel={i18n.translate('loginScreen.version2.fields.optMarketing')}
                fieldName="marketing_opt_in"
                fieldType="checkbox"
                line={false}
                title={i18n.translate('loginScreen.version2.fields.optMarketing')}
                checked={this.props.userInput.marketing_opt_in}
                required={false}
                userSelect={false}
                key={this.props.userInput.marketing_opt_in}
              />
            </span>
          </span>
        )}

        <div className="login__form--buttons">
          {window.location.pathname.includes('/register-mobile') &&
            window.location.pathname.includes('/login/register-mobile') &&
            window.location.pathname.includes('/login/quick-register-mobile') && (
              <style>
                {
                  '\
              #openWidget { display: none; bottom: 3rem; } #logoHeader { display: none; } .cookieConsent { display: none !important; } .loginView__content--logo { display: none !important; }'
                }
              </style>
            )}
          {window.location.pathname !== '/register-mobile' &&
            window.location.pathname !== '/login/register-mobile' &&
            window.location.pathname !== '/login/quick-register-mobile' && (
              <Link to="/login">
                <button type="button" onClick={this.props.back} className="Email__input--button btnInverse">
                  {i18n.translate('general.back')}
                </button>
              </Link>
            )}
          <button type="submit" onClick={this.props.submit} className="Email__input--button">
            {this.props.loadingAnimRegister ? (
              <span>
                <FontAwesomeIcon icon={['fas', 'circle-notch']} spin />
              </span>
            ) : (
              i18n.translate('loginScreen.register')
            )}
          </button>
        </div>
      </div>
    );
  }
}

RegisterTrade.propTypes = {
  changeItem: PropTypes.func.isRequired,
  defaultVal: PropTypes.string,
  country: PropTypes.string.isRequired,
  change: PropTypes.func.isRequired,
  submit: PropTypes.func.isRequired,
  loadingAnimRegister: PropTypes.bool.isRequired,
  passwordField: PropTypes.bool.isRequired,
  userInput: PropTypes.shape({
    reg_email: PropTypes.string,
    reg_first_name: PropTypes.string,
    reg_last_name: PropTypes.string,
    reg_agency_name: PropTypes.string,
    reg_country: PropTypes.string,
    reg_city: PropTypes.string,
    reg_state: PropTypes.string,
    reg_agency_affiliation: PropTypes.string,
    reg_host_agency_name: PropTypes.string,
    reg_zip_code: PropTypes.string,
    marketing_opt_in: PropTypes.bool,
    opt_in_marketing: PropTypes.bool,
  }),
};

RegisterTrade.defaultProps = {
  defaultVal: '',
  userInput: {
    reg_email: '',
    reg_first_name: '',
    reg_last_name: '',
    reg_agency_name: '',
    reg_country: '',
    reg_city: '',
    reg_state: '',
    reg_agency_affiliation: '',
    reg_host_agency_name: '',
    reg_zip_code: '',
    marketing_opt_in: false,
    opt_in_marketing: false,
  },
};
